import { ChangeDetectorRef, Component, EventEmitter, inject, OnDestroy, Output, ViewChild } from '@angular/core';

import { distinctUntilChanged, map, Subscription, tap } from 'rxjs';

import { ByocService } from '../../../../service/byoc.service';
import { ByocEpisodeService } from '../../../service/episode.service';

import { Pagination } from '@app/core/model/http-pagination.model';
import { UserSimple } from '@app/user';
import { AffectedService } from '../services/affected.service';
import { PerfectScrollbarDirective } from '@app/shared/perfect-scrollbar/perfect-scrollbar.directive';

@Component({
    selector: 'app-byoc-episode-step-users-list',
    templateUrl: './list.component.html',
    styleUrls: ['./list.component.scss'],
    standalone: false
})
export class ByocEpisodeStepUsersListComponent implements OnDestroy {
    @Output() usersCount: EventEmitter<number> = new EventEmitter<number>();

    @ViewChild('ps', { read: PerfectScrollbarDirective, static: true })
    psRef?: PerfectScrollbarDirective;

    private readonly changeDetectorRef = inject(ChangeDetectorRef);
    private readonly byocService = inject(ByocService);
    private readonly byocEpisodeService = inject(ByocEpisodeService);
    private readonly affectedService = inject(AffectedService);

    users$ = this.affectedService.affected$.pipe(
        map((affected) => affected.users.items),
        /**
         * Dectect changes for scrollbar padding update
         */
        tap(() => setTimeout(() => this.changeDetectorRef.detectChanges(), 200)),
    );

    appending$ = this.affectedService.affected$.pipe(
        map((affected) => affected.users.appending),
        distinctUntilChanged(),
    );

    /**
     * Subscriptions
     */
    private subscriptions: Subscription = new Subscription();

    ngOnDestroy() {
        this.subscriptions.unsubscribe();
    }

    get scrollbarYEnabled(): boolean {
        return this.psRef?.ps?.scrollbarYActive ?? false;
    }

    /**
     * Y Reached end event
     */
    psYReachEnd() {
        this.append();
    }

    /**
     * Append
     */
    private append(): void {
        if (this.affectedService.appending || this.affectedService.hasAllUsersLoaded) {
            return;
        }

        this.affectedService.setAffectedUsersAppending(true);

        this.changeDetectorRef.detectChanges();
        this.subscriptions.add(
            this.byocService
                .episodeAffectedUsers(
                    <string>this.byocEpisodeService.form.value.courseId,
                    this.affectedService.affected.users.lazyload.limit,
                    this.affectedService.affected.users.lazyload.offset.suffixPosition,
                )
                .pipe(
                    tap((data: { users: UserSimple[]; pagination: Pagination }) => {
                        this.affectedService.setAffectedUsers([...(this.affectedService.affected.users.items ?? []), ...data.users], {
                            total: data.pagination.totalItems,
                            suffixPosition: data.users.length,
                        });
                        this.affectedService.setAffectedUsersAppending(false);
                        this.psRef?.ps?.update();
                        this.changeDetectorRef.detectChanges();
                    }),
                )
                .subscribe(),
        );
    }
}
